/*
Documentation

this page holds all the routes for the dashboard layout

*/

// import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings';

import ProjectsAll from '../pages/projects/All'
import ProjectsView from '../pages/projects/View'

import CompanyPayments from '../pages/projects/CompanyPayments'
import CompanyBugs from '../pages/projects/CompanyBugs'
import CompanyRequests from '../pages/projects/CompanyRequests'

export default [

    {
        divider: "My Dashboard",
        name: 'Projects',
        icon: 'fas fa-home text-primary',
        path: "/",
        component: ProjectsAll,
        show_in_sidebar: true
    },
    {
        name: 'Invoices',
        icon: 'fas fa-calendar-check text-info',
        path: "/company/invoices",
        component: CompanyPayments,
        show_in_sidebar: true
    },
    {
        name: 'Additional Requests',
        icon: 'fas fa-code-branch text-success',
        path: "/company/requests",
        component: CompanyRequests,
        show_in_sidebar: true
    },
    {
        name: 'Reported Bugs',
        icon: 'fas fa-bug text-danger',
        path: "/company/bugs",
        component: CompanyBugs,
        show_in_sidebar: true
    },
    {
        path: "/projects/:_id",
        component: ProjectsView,
        show_in_sidebar: false
    },

    

    {
        divider: "Profile",
        name: 'Settings',
        icon: 'fas fa-cogs text-success',
        path: "/settings",
        component: Settings,
        show_in_sidebar: true
    },

]